function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "pencil",
  d: "M19.365.851a3.013,3.013,0,0,0-4.257,0L14.042,1.923,2.7,13.26l-.024.024c-.006.006-.006.012-.012.012-.012.018-.03.036-.042.054s-.006.006-.006.012-.018.03-.03.048-.006.012-.012.018-.012.03-.018.048-.006.006-.006.012L.032,21.057a.592.592,0,0,0,.144.614.606.606,0,0,0,.428.175.71.71,0,0,0,.193-.03l7.562-2.523c.006,0,.006,0,.012-.006a.218.218,0,0,0,.054-.024.021.021,0,0,0,.012-.006c.018-.012.042-.024.06-.036s.036-.03.054-.042.012-.006.012-.012.018-.012.024-.024L21,6.733a3.012,3.012,0,0,0,0-4.257ZM8.166,17.878l-4.19-4.19L14.464,3.2l4.19,4.19ZM3.385,14.8l3.661,3.661-5.5,1.83ZM20.147,5.891l-.638.644L15.318,2.344l.644-.644a1.806,1.806,0,0,1,2.553,0l1.638,1.638A1.812,1.812,0,0,1,20.147,5.891Zm0,0",
  transform: "translate(0 0.029)",
  fill: "#fff"
});

var SvgNotes = function SvgNotes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.877,
    height: 21.875,
    viewBox: "0 0 21.877 21.875",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notes.b99f7c76.svg";
export { ForwardRef as ReactComponent };